import _ from "underscore";

import { Level1Id, Level2Id, Level3Id, Level4Id, Level5Id } from "masterformat";

import level1 from "../../../../resources/masterformat/level1_enum.json";
import level2 from "../../../../resources/masterformat/level2_enum.json";
import level3 from "../../../../resources/masterformat/level3_enum.json";
import level4 from "../../../../resources/masterformat/level4_enum.json";
import level5 from "../../../../resources/masterformat/level5_enum.json";

import type { Selected } from "type_aliases";
export type MasterformatLevel1Filter = { [code in Level1Id]: Selected };
export type MasterformatLevel2Filter = { [code in Level2Id]: Selected };
export type MasterformatLevel3Filter = { [code in Level3Id]: Selected };
export type MasterformatLevel4Filter = { [code in Level4Id]: Selected };
export type MasterformatLevel5Filter = { [code in Level5Id]: Selected };

export const defaultMasterformatFilter = {
  level1: _.mapObject(level1, () => 1) as MasterformatLevel1Filter,
  level2: _.mapObject(level2, () => 1) as MasterformatLevel2Filter,
  level3: _.mapObject(level3, () => 1) as MasterformatLevel3Filter,
  level4: _.mapObject(level4, () => 1) as MasterformatLevel4Filter,
  level5: _.mapObject(level5, () => 1) as MasterformatLevel5Filter
}
